@let frameLength = frameLength$ | async;
@let resourcesColumnWidthPx = resourcesColumnWidthPx$ | async;
@let isLoadingUnassignedShifts = isLoadingUnassignedShifts$ | async;
@let isRefreshingUnassignedShifts = isRefreshingUnassignedShifts$ | async;
@let hideLoaderWhenLoadingUnassignedShiftsOrActivities =
  hideLoaderWhenLoadingUnassignedShiftsOrActivities$ | async;
@let isLoadingUsers = isLoadingUsers$ | async;
@let selectedTab = selectedTab$ | async;
@let isUnassignedRegionExpanded = isUnassignedRegionExpanded$ | async;
@let hasUpdateShiftPermission =
  can(RoleAction.Update, RolePermissionSubject.Shift);
@let isAssignmentMode = dragAndDropModeService.isAssignmentMode$ | async;
@let visibleDaysRange = visibleDaysRange$ | async;
@let timeframe = timeframe$ | async;
@let unassignedRegionHeightPx = unassignedRegionHeightPx$ | async;

<ng-container>
  <div
    id="left-container"
    [style.width.px]="resourcesColumnWidthPx"
    [style.min-width.px]="resourcesColumnWidthPx"
    [ngClass]="{ 'left-side-green-border': isUnassignedRegionExpanded }"
  >
    @if (
      isUnassignedRegionExpanded &&
      unassignedRegionResizeService.isLeftPanelContentVisible()
    ) {
      <div class="green-square">{{ 'general.unassigned' | translate }}</div>
      <wilson-unassigned-region-segment
        [resourcesColumnWidthPx]="resourcesColumnWidthPx"
        [selectedTab]="selectedTab"
        [isLoadingUnassignedShifts]="
          (!!isLoadingUnassignedShifts || !!isRefreshingUnassignedShifts) &&
          !hideLoaderWhenLoadingUnassignedShiftsOrActivities
        "
        [isLoadingUnassignedActivities]="false"
        [isCellViewMode]="true"
      ></wilson-unassigned-region-segment>
      @if (selectedTab === tabOptions.UnassignedShifts) {
        <wilson-unassigned-region-search-filter
          [resourcesColumnWidthPx]="
            (resourcesColumnWidthPx || 0) - FILTER_PIXEL_ADJUSTMENT
          "
          [unassignedShifts]="unassignedShiftsWithoutActivities$ | async"
        ></wilson-unassigned-region-search-filter>
      }
    }
    <wilson-assign-all-shift-without-activities-button
      [isLoadingUsers]="!!isLoadingUsers"
      [class.d-none]="unassignedRegionResizeService.isDragging()"
    ></wilson-assign-all-shift-without-activities-button>
  </div>
  <div
    #rightContainerWrapper
    class="right-container-wrapper"
    (dragover)="dragover($event)"
    (drop)="drop($event)"
    (dragleave)="dragleave($event)"
    (scroll)="updateScrollingPosition($event)"
    [ngClass]="{ 'right-side-green-border': isUnassignedRegionExpanded }"
  >
    <div
      class="drop-zone"
      [ngClass]="{ 'expanded-drop-zone': isUnassignedRegionExpanded }"
      [class.d-none]="!isHovered()"
    ></div>
    <wilson-unassigned-region-toggle
      [isExpanded]="!!isUnassignedRegionExpanded"
      (modelChange)="manualToggleRegion($event)"
    ></wilson-unassigned-region-toggle>
    <wilson-unassigned-region-cell-view-shifts-details-render
      [style.width.px]="frameLength"
      [numberOfShiftPerDayRecord]="(numberOfShiftPerDayRecord$ | async) || {}"
      [filteredUnassignedShiftStacks]="
        (filteredUnassignedShiftStacks$ | async) || []
      "
      [pixelWidthPerDay]="(pixelWidthPerDay$ | async) || 0"
      [isUnassignedRegionExpanded]="!!isUnassignedRegionExpanded"
      [unassignedRegionHeightPx]="unassignedRegionHeightPx"
      [shiftIdsToHighlight]="(shiftIdsToHighlight$ | async) || []"
      [isTooltipVisible]="
        !!(
          timelineShiftDragAndDropDirectiveHelperService.isTooltipVisible$
          | async
        )
      "
      [isShiftVisible]="
        !!(
          timelineShiftDragAndDropDirectiveHelperService.isShiftVisible$ | async
        )
      "
      [isShiftDraggable]="true"
      [isSelectionEnabled]="true"
      [showShiftValidation]="
        !!('portal-validation-without-assignments' | featureFlagPure | async)
      "
      [visibleDaysRange]="visibleDaysRange"
      [frameLength]="frameLength"
      [timeframe]="timeframe"
      (toggleRegion)="manualToggleRegion(!!!isUnassignedRegionExpanded)"
      (dragStart)="
        unassignedCellViewShiftsWithoutActivitiesDragHandlerService.dragStart(
          $event,
          !!hasUpdateShiftPermission,
          !!isAssignmentMode
        )
      "
      (dragEnd)="
        unassignedCellViewShiftsWithoutActivitiesDragHandlerService.dragEnd()
      "
      (visibleShiftIds)="handleVisibleShiftIds($event)"
    ></wilson-unassigned-region-cell-view-shifts-details-render>
  </div>
</ng-container>
